import React from 'react';
import styles from './footer-xsci.module.css'
// import {useTranslation} from "react-i18next";

const CompanySection = () => {
    // const {t, i18n} = useTranslation();


    return (

        <div className={`col-md-3 col-12 my-sm-0 mt-5 ${styles.section_container}`}>
            <ul className="list-unstyled" >
                <li className={`mt-md-3 mt-4 ${styles.section_title}`}>Resources</li>
                <li className={styles.section_li}>
                    <a href="/" className={styles.section_link}>Home</a>
                </li>
                {/*<li className={styles.section_li}>*/}
                {/*    <a href="/about" className={styles.section_link}>About</a>*/}
                {/*</li>*/}
            </ul>
        </div>

    );
};

export default CompanySection;